import { render, staticRenderFns } from "./ConversationBox.vue?vue&type=template&id=002d37c8&scoped=true&"
import script from "./ConversationBox.vue?vue&type=script&lang=js&"
export * from "./ConversationBox.vue?vue&type=script&lang=js&"
import style0 from "./ConversationBox.vue?vue&type=style&index=0&id=002d37c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002d37c8",
  null
  
)

export default component.exports